module.exports = __webpack_public_path__ + "static/b1-04648559a5ffd6fba7d99fea2d40fbed.jpg";